import {helpers} from '@/ft-vue-core'

const {setGlobalValue} = helpers

export default {
  watch: {
    selectedItemId () {
      if (this.selectedItemId !== undefined) {
        console.log('Disable list loading')
        this.loadedSearchFilters = false
      }
    },
    selectedEventsCostsFilter (val) {
      // Clear priceCategoryId filter if selected event filter doesn't have it
      if (!val || !val.find(c => c.id === this.searchFilter.eventCostId)) {
        this.searchFilter.eventCostId = null
      }
    },
    selectedEventsFilter (val) {
      if (val && val.length) this.searchFilter.mealPeriodIds = []
    },
    selectedMealPeriodsFilter: {
      handler () {
        if (this.selectedMealPeriodsFilter && this.selectedMealPeriodsFilter.length) {
          this.searchFilter.eventId = null
        }
      },
      deep: true
    },
    searchFilter: {
      handler () {
        if (this.showItem) return
        console.log('Search Filter Changed', this.searchFilter)
        // Save list filter for this route.  It will be used again when we return
        console.log('Saving filter for :' + this.getSavedSearchFilterId())
        setGlobalValue(this.getSavedSearchFilterId(), this.searchFilterName, this.searchFilter)
        this.loadList()
      },
      deep: true
    }
  }
}
